import { Helmet } from 'react-helmet-async';
import EditClinicTelehealthView from 'src/sections/clinic-dashboard/therapies/therapy-edit-view';

export default function ClinicEditTelehealthPage() {
  return (
    <>
      <Helmet>
        <title>Edit Telehealth</title>
      </Helmet>

      <EditClinicTelehealthView />
    </>
  );
}
